export default "__VITE_ASSET__BDs7L58___"